/*
 * Small copy fix on the merchant's request: the full Manifest page's blurb
 * ("What came over the counter this week, what we could verify...") reads
 * like a curated in-house intake log. It's really just the whole catalog,
 * unsorted — swap in copy that says that plainly. Home page's "Featured This
 * Week" teaser blurb is untouched; this only affects the full Manifest page.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }
  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    if (this.state.page !== 'home') {
      out.manifestBlurb = 'The entire stock on file, uncategorized — every item currently listed, in one unsorted sheet.';
    }
    return out;
  };
})();
